<template lang="pug">
b-modal#depositTier(
  ref="depositTier"
  :title="$t('ui.deposit_tier')"
  centered
  no-fade
  no-close-on-backdrop
  hide-footer
  :busy="loading"
  size="xl"
  @show="reset"
  @shown="shown")
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-6.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-sync"
                  :text="$t('ui.refresh')"
                  type="button"
                  @click="getDepositTierList()"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12(v-if="isEditAccess")
                b-button(@click="onAddDt" type="button" variant="info" size="sm" v-if="totalRow < 5")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_deposit_tier") }}
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th.text-right(width="8%")
                          span(:title="$t('ui.deposit')") {{ $t('ui.deposit') }}
                        th(width="8%")
                          span(:title="$t('ui.reward')") {{ $t('ui.reward') }}
                        th.text-right(width="8%")
                          span(:title="$t('ui.created_date')") {{ $t('ui.created_date') }}
                        th.text-right(width="8%")
                          span(:title="$t('ui.modified_date')") {{ $t('ui.modified_date') }}
                        th.text-center(width="5%" v-if="isEditAccess")
                          span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="depositTierList.length == 0")
                        td(colspan="6").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in depositTierList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td.text-right
                          span.font-weight-bold(:title="$n(item.deposit, 'currency')" :class="$helpers.fontClassName(item.deposit)") {{ $n(item.deposit, 'currency') }}
                        td
                          span(:title="item.reward") {{ item.reward }}
                        td.text-right
                          span(:title="item.created_by") {{ item.created_by }}
                          br
                          span(:title="$moment(item.created_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_at).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.text-right
                          span(:title="item.modified_by") {{ item.modified_by ? item.modified_by : "-" }}
                          br
                          span(:title="$moment(item.modified_at).format('YYYY-MM-DD, HH:mm:ss')") {{ item.modified_at ? $moment(item.modified_at).format('YYYY-MM-DD, HH:mm:ss') : "-" }}
                        td.actions.text-center.align-middle(v-if="isEditAccess")
                          span.mr-2
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                              href="javascript:void(0)"
                              @click="onEditDt(item)"
                              :title="$t('ui.edit')"
                              )
                          span
                            a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(
                              href="javascript:void(0)"
                              @click="onDelete(item)"
                              :title="$t('ui.delete')"
                              )

  adddeposittier(ref="addDepositTier" :operatorID="operatorID" @clicked="addDepositTier" @failed="handleFailedDepositTier")
  editdeposittier(ref="editDepositTier" :operatorID="operatorID" :itemDt="selectedDepositTier" @clicked="afterEditDepositTier" @failed="handleFailedDepositTier")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import adddeposittier from "@/components/promo/depositTier/addDepositTier.vue";
import editdeposittier from "@/components/promo/depositTier/editDepositTier.vue";

export default {
  components: {
    SubmitButton,
    adddeposittier,
    editdeposittier
  },
  props: {
    item: {
      type: Object
    },
    operatorID: {
      type: String
    }
  },
  data() {
    return {
      depositTierList: [],
      selectedDepositTier: null,
      loading: false,
      totalRow: 0,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_deposittier");
    }
  },
  methods: {
    onAddDt(e) {
      this.$refs.addDepositTier.$refs.addDepositTier.show();
    },
    onEditDt(e) {
      this.selectedDepositTier = e;
      this.$refs.editDepositTier.$refs.editDepositTier.show();
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.depositTierList = [];
      this.selectedDepositTier = null;
    },
    shown() {
      this.getDepositTierList();
    },
    getDepositTierList() {
      this.getDepositTierCount();
      let url = config.triggerOpDepositTierListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        operator_id: this.operatorID
      };
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.depositTierList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getDepositTierCount: function() {
      let url = config.triggerOpDepositTierCountUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.totalRow = response.data.dt.length > 0 ? response.data.dt[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onDelete:function(e) {
      this.$helpers
        .alert({
          title: this.$t("ui.delete"),
          text: this.$t("message.delete_deposit_tier_confirm", { deposit: e.deposit, reward: e.reward }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDelete(e);
          }
        });
    },
    confirmDelete: function(e) {
      let url = config.triggerOpDepositTierDeleteUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        operator_id: this.operatorID,
        tier_id: e.id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getDepositTierList();
                this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addDepositTier() {
      this.getDepositTierList();

      this.$helpers.showDialog(this.$t("ui.combine.add_deposit_tier"), this.$t("message.success"), "success");
    },
    afterEditDepositTier() {
      this.getDepositTierList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_deposit_tier"), this.$t("message.success"), "success");
    },
    handleFailedDepositTier(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
